import forEach from "@homer.utility/foreach";

class Node {
    constructor() {
        const node = document.createElement("link");

        node.setAttribute("rel", "canonical");

        return node;
    }
}

export default class Canonical {
    #node = [];
    #current = [];

    constructor(nodes) {
        forEach(nodes, (node) => {
            this.#node.push(node);
            this.#current.push(node.getAttribute("href"));
        });

        this.update(this.#current);
    }

    get current() {
        return this.#current;
    }

    update(canonicals) {
        this.#current = canonicals;

        forEach(canonicals, (url, index) => {
            const node = this.#node[index] || (this.#node[index] = new Node());

            node.setAttribute("href", url);
        });

        forEach(this.#node, (node, index) => {
            if (!canonicals[index] && node.isConnected) {
                node.parentNode.removeChild(node);

                return;
            }

            if (!node.isConnected) {
                document.head.appendChild(node);
            }
        });
    }
}
